import Store from "store/store";
import User from "../model/user.model";
import Branch from "../model/branch.model";

export default class Settings {

    static load() {
        var settings = Store.get('settings') || {};
        settings = new Settings(settings);
        return settings;
    }

    constructor(data) {
        this.reset();

        if (data) {
            Object.assign(this, data);

            if (this.user) {
                this.user = new User(this.user);
            }

            if (this.data) {
                this.branch = new Branch(this.branch);
            }
        }
    }

    httpUrl(path) {
        return this.httpUrlWithHost(this.host, path);
    }

    httpUrlWithHost(host, path) {
        let httpUrl = 'https://' + host + '.myneonis.de'
            + (this.port ? ':' + this.port : '')
            + this.basePath;

        if (path) {
            httpUrl = httpUrl + (path.startsWith('/') ? path : '/' + path);
        }

        return httpUrl;
    }

    reset() {
        this.host = '';
        this.port = '';
        this.basePath = "/mitarbeiter/seam/resource/rest";
        this.branch = new Branch();
        this.user = new User();
        this.calendarWithSunday = false;
        this.calendarOnlyOpenBookings = false;
        this.calendarFirstHour = 0;
        this.calendarLastHour = 23;
        this.calendarForceSplitView = false;
    }

    save() {
        Store.set('settings', this);
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/settings.model.js